import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let listeners = [];

export function useContent() {
  const [content, setContent] = useState(cache || {});
  useEffect(() => {
    if (cache) {
      setContent(cache);
      return;
    }
    api
      .get("/content")
      .then((r) => {
        cache = r.data;
        setContent(cache);
        listeners.forEach((fn) => fn(cache));
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    const fn = (c) => setContent({ ...c });
    listeners.push(fn);
    return () => {
      listeners = listeners.filter((l) => l !== fn);
    };
  }, []);
  return content;
}

export function updateContentCache(key, value) {
  if (!cache) cache = {};
  cache[key] = value;
  listeners.forEach((fn) => fn(cache));
}

export function t(content, key, fallback) {
  return (content && content[key]) || fallback;
}

export function parseHiddenSet(content) {
  const raw = content && content["hidden.blocks"];
  if (!raw) return new Set();
  try {
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.map(String));
  } catch { return new Set(); }
}

export function isHidden(content, id) {
  return parseHiddenSet(content).has(id);
}
